export const environment = {
  // apiUrl: 'https://backend-dev.universidaddeldeporte.edu.mx/api/edupep-backend',
  apiUrl: 'http://localhost:8080/api/edupep-backend',
  // apiUrlV2: 'https://backend-dev.universidaddeldeporte.edu.mx/api/v2'
};
